import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginForm from "./components/Login";
import Dashboard from "./components/Dashboard";
import WorkForm from "./components/WorkForm";
import ProtectedRoute from "./components/ProtectedRoute";

// Layout for consistent layout across pages
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-screen-xl p-6 mx-auto">{children}</div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Layout><LoginForm /></Layout>} />
        
        {/* Protected routes */}
        <Route path="/" element={<Layout><WorkForm /></Layout>} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
